import { createSlice } from '@reduxjs/toolkit'
let ss =[
  {key: 'v2',value:'#FFFFFF'},
  {key: 'v1',value:'#FFFFFF'},
  {key: 'v3',value:'#FFFFFF'}
  
];

let initialState = {
    SuitPartsList:ss,
    PatternValue:'',
    IsGripper:'no',
    IsPocket:'no',
    IsContrastStiching:'yes',
    IsCellPhoneZipperPocket:'no',
    IsSplitTorso:'no',
    IsAreaTowPatterns:null,
    IsAreaThreePatterns:null,
    svgRef:null,
    downloadImageSrc:"",
    globalCanvas:null,
      fit:"",
      size:"",
      isLoading:false
}

export const mainSlice = createSlice({
  name: 'mainSlice',
  initialState,
  reducers: {
  setSuitPartsList : (state,action) => {
    let index = state.SuitPartsList.findIndex(x => x.key == action.payload.selector);
		let array = [...state.SuitPartsList];
		array[index]['value'] = action.payload.color;
    localStorage.setItem("SuitPartsList ",  array);
    state.SuitPartsList=array;
    // dispatch({type: "OrderList" , payload : data})
},
setFullSuitPartsList : (state,action) => {
  debugger
  state.SuitPartsList=action.payload;
  // dispatch({type: "OrderList" , payload : data})
},
setPatternValue : (state,action) => {
  debugger
  state.PatternValue=action.payload;
   
},
setGripper : (state,action) => {
   
  state.IsGripper=action.payload;
   
},
setPocket : (state,action) => {
   
  state.IsPocket=action.payload;
   
},
setSplitTorso : (state,action) => {
  
  state.IsSplitTorso=action.payload;
   
},
setIsAreaTowPatterns: (state,action) => {
  
  state.IsAreaTowPatterns=action.payload;
   
},
setIsAreaThreePatterns: (state,action) => {
  
  state.IsAreaThreePatterns=action.payload;
   
},
SetContrastStiching: (state,action) => {
  
  state.IsContrastStiching=action.payload;
   
},
SetIsCellPhoneZipperPocket: (state,action) => {
  
  state.IsCellPhoneZipperPocket=action.payload;
   
},
setSVGREF: (state,action) => {
  
  state.svgRef=action.payload;
   
},
setdownloadImageSrc: (state,action) => {
  
  state.downloadImageSrc=action.payload;
   
},
setglobalCanvas: (state,action) => {
  
  state.globalCanvas=action.payload;
   
},
setSizingFit: (state,action) => {
  state.fit = action.payload
},
setSizingSize: (state,action) => {
  state.size = action.payload
},
setIsLoading: (state,action) => {
  state.isLoading = action.payload
},

  },
})

// Action creators are generated for each case reducer function
export const {setIsLoading, setSuitPartsList,setFullSuitPartsList,setPatternValue,setGripper,setSplitTorso,setPocket,setIsAreaTowPatterns,setIsAreaThreePatterns,SetContrastStiching,SetIsCellPhoneZipperPocket , setSVGREF , setdownloadImageSrc,setglobalCanvas , setSizingFit,setSizingSize} = mainSlice.actions

export default mainSlice.reducer

